import { SearchBarWithAvatarsProps } from "./types"
// import { StyleSheet } from "~/ui/primitives"
import React from "react"
import SearchUser from "./components/search"
import Avatars from "./components/avatars"
import styled from '~/ui/styled'

const SearchRow = styled.View`
  flex-direction: row;
  align-items: center;
  padding: 10px 12px;
  background-color: ${({ theme }) => theme.colors.blockBackground};
`

const SearchBarWithAvatars: React.FC<SearchBarWithAvatarsProps> = ({
  selecteds,
  search,
  setSearch,
  inputSetting,
}) => {
  return (
    <SearchRow>
      <Avatars selecteds={selecteds}></Avatars>
      <SearchUser
        inputSetting={{
          ...inputSetting,
          value: search,
          onChangeText: setSearch,
        }}
      />
    </SearchRow>
  )
}

export default SearchBarWithAvatars
